import {
  Clock, CheckCircle2, XCircle, Search, Eye, Send, ListChecks
} from "lucide-react";
import { formatPYG } from "../../utils/format";

export const WORKFLOW_STEPS = [
  { key: "recepcion", label: "Recepción", short: "Recep." },
  { key: "computo", label: "Cómputo", short: "Cómputo" },
  { key: "cotizacion", label: "Cotización", short: "Cotiz." },
  { key: "revision", label: "Revisión", short: "Revisión" },
  { key: "enviado", label: "Enviado", short: "Enviado" },
  { key: "aprobado", label: "Aprobado", short: "Aprobado" },
];

export const STATUS_META = {
  borrador:   { label: "Borrador",   color: "bg-gray-100 text-gray-600",    icon: Clock,        wfKey: "recepcion" },
  recepcion:  { label: "Recepción",  color: "bg-slate-100 text-slate-600",  icon: Clock,        wfKey: "recepcion" },
  computo:    { label: "Cómputo",    color: "bg-blue-100 text-blue-700",    icon: ListChecks,   wfKey: "computo" },
  cotizacion: { label: "Cotización", color: "bg-violet-100 text-violet-700",icon: Search,       wfKey: "cotizacion" },
  revision:   { label: "Revisión",   color: "bg-amber-100 text-amber-700",  icon: Eye,          wfKey: "revision" },
  enviado:    { label: "Enviado",    color: "bg-blue-100 text-blue-700",    icon: Send,         wfKey: "enviado" },
  aprobado:   { label: "Aprobado",   color: "bg-emerald-100 text-emerald-700", icon: CheckCircle2, wfKey: "aprobado" },
  rechazado:  { label: "Rechazado",  color: "bg-red-100 text-red-700",      icon: XCircle,      wfKey: null },
};

export const NEXT_STEP_LABEL = {
  recepcion:  "Iniciar Cómputo",
  borrador:   "Iniciar Cómputo",
  computo:    "Pasar a Cotización",
  cotizacion: "Enviar a Revisión",
  revision:   "Enviar al Cliente",
  enviado:    "Aprobar",
};

export const TIPO_META = {
  obra:     { label: "Obra",     color: "bg-amber-100 text-amber-700" },
  proyecto: { label: "Proyecto", color: "bg-purple-100 text-purple-700" },
  varios:   { label: "Varios",   color: "bg-teal-100 text-teal-700" },
};

export const UNIDADES = ["un", "ml", "m²", "m³", "kg", "rollo", "caja", "juego", "glo", "hs", "día", "mes"];
export const DEFAULT_PCT = { ganancia_mat_pct: 10, ga_pct: 10, gmo_pct: 45 };
export const opts = { withCredentials: true };
export const fmt = (v) => (v != null ? formatPYG(v) : "—");

// Fix IP (2026-10-30): "no hay sustitución automática del texto o número, sino que cuando lo pega, lo pega encimado o al
// lado del ya existente" (CEN). Como en una planilla: al entrar a una celda de número se selecciona su contenido y lo que se
// escribe o se pega lo reemplaza. El clic que entra no deshace la selección; los siguientes ubican el cursor como siempre.
export const seleccionarAlEntrar = {
  onFocus: (e) => { e.target.select(); e.target.dataset.entrada = String(Date.now()); },
  onMouseUp: (e) => { if (Date.now() - Number(e.target.dataset.entrada || 0) < 600) e.preventDefault(); delete e.target.dataset.entrada; },
};
